import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { loginLogic } from '@_features/auth';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { InformationPopup } from '@_shared/ui/Popup';

export function LogoutPopup() {
	const { popLayer } = useUILayerStore();
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	function handleLogout() {
		loginLogic.logout();
		queryClient.clear();
		popLayer();
		navigate('/');
	}

	return (
		<InformationPopup.Container closePopup={popLayer}>
			<InformationPopup.TextContainer>
				<InformationPopup.Title>정말 로그아웃 하시겠습니까?</InformationPopup.Title>
			</InformationPopup.TextContainer>
			<InformationPopup.ButtonContainer>
				<InformationPopup.Button type="deny" onClick={popLayer}>
					취소
				</InformationPopup.Button>
				<InformationPopup.Button type="confirm" onClick={handleLogout}>
					확인
				</InformationPopup.Button>
			</InformationPopup.ButtonContainer>
		</InformationPopup.Container>
	);
}
